/**
 * Reviews showcase: "Ver más / Ver menos" pagination and a per-visitor "was
 * this helpful" vote (stored in this browser only via localStorage — it is
 * not shared between visitors, there is no backend).
 */
(function () {
  function initReviewsShowcase(root) {
    var list = root.querySelector('[ref="reviewList"]');
    var loadMoreBtn = root.querySelector('[ref="loadMoreBtn"]');
    var loadLessBtn = root.querySelector('[ref="loadLessBtn"]');
    if (!list) return;

    // Each review is a "review-card-outer" wrapper (carries Shopify's block
    // attributes so the editor can select it) around the actual "review-card"
    // content (what we show/hide). Keeping the collapse logic off the outer
    // wrapper matters: the theme editor forces any element tied to a block's
    // editor attributes to stay visible, so hiding has to happen on the
    // inner element instead.
    function innerOf(outer) {
      return outer.querySelector('.review-card');
    }

    var cardOuters = Array.prototype.slice.call(list.querySelectorAll('.review-card-outer'));

    var perPage = cardOuters.length;
    if (loadMoreBtn) {
      var parsedPerPage = parseInt(loadMoreBtn.getAttribute('data-per-page'), 10);
      if (parsedPerPage > 0) perPage = parsedPerPage;
    }

    var visibleLimit = perPage;

    function render() {
      cardOuters.forEach(function (outer, index) {
        var inner = innerOf(outer);
        if (!inner) return;
        inner.style.display = index < visibleLimit ? '' : 'none';
      });

      if (loadMoreBtn) {
        loadMoreBtn.classList.toggle('reviews-showcase__btn--is-hidden', cardOuters.length <= visibleLimit);
      }
      if (loadLessBtn) {
        loadLessBtn.classList.toggle('reviews-showcase__btn--is-hidden', visibleLimit <= perPage);
      }
    }

    render();

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleLimit += perPage;
        render();
      });
    }

    if (loadLessBtn) {
      loadLessBtn.addEventListener('click', function () {
        visibleLimit = perPage;
        render();
        if (typeof list.scrollIntoView === 'function') {
          list.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // "Was this helpful" — local-only vote, persisted per browser.
    var storageKeyPrefix = 'reviews-showcase-vote:';

    cardOuters.forEach(function (outer) {
      var card = innerOf(outer);
      if (!card) return;
      var reviewId = card.dataset.reviewId;
      if (!reviewId) return;
      var storageKey = storageKeyPrefix + reviewId;
      var voteButtons = card.querySelectorAll('.review-card__vote');

      var storedVote = null;
      try {
        storedVote = window.localStorage.getItem(storageKey);
      } catch (error) {
        storedVote = null;
      }

      if (storedVote) {
        voteButtons.forEach(function (button) {
          if (button.getAttribute('data-vote') === storedVote) {
            button.classList.add('is-voted');
          }
        });
      }

      voteButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var current = null;
          try {
            current = window.localStorage.getItem(storageKey);
          } catch (error) {
            current = null;
          }
          if (current) return; // already voted on this device

          var voteType = button.getAttribute('data-vote');
          var countEl = button.querySelector('[data-vote-count]');
          if (countEl) {
            countEl.textContent = String(Number(countEl.textContent || '0') + 1);
          }
          button.classList.add('is-voted');

          try {
            window.localStorage.setItem(storageKey, voteType);
          } catch (error) {
            /* localStorage unavailable — vote still reflects visually for this page view */
          }
        });
      });
    });
  }

  var sections = document.querySelectorAll('.reviews-showcase');
  sections.forEach(initReviewsShowcase);
})();
